import React from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../contexts/CartContext";

function ShoppingCartIcon() {
  const { itemCount } = useCart();
  const navigate = useNavigate();

  if (itemCount === 0) return null;

  function handleClick() {
    navigate("/cart");
  }

  return (
    <div className="shopping-cart-icon" onClick={handleClick} role="button" tabIndex={0}>
      <div className="cart-widget-container">
        <div className="cart-widget">
          <i className="glyphicon glyphicon-list" />
          <div className="cart-element cart-label">My Resource List</div>
          <div className="circle cart-element">
            <div className="count">{itemCount}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShoppingCartIcon;
